module.exports = __webpack_public_path__ + "img/CM-SS-CA-Chevy-Playful.887f20e2.jpg";